import React, { useState, Fragment } from "react";
import TimelineSingleStep from "./TimelineSingleStep";

/******************************************************************

HOW TO USE

const data = [
    {
        label: "Programa de fidelidade"
    },
    {
        label: "Dados de cadastro"
    },
    {
        label: "Oferta de milhas"
    }
];


<TimelineSteps
    data={data}         //required
    step={2}            //required
    approvedSteps={1}
    />

******************************************************************/

const TimelineSteps = ({ data, step, approvedSteps }) => {
	return (
		<Fragment>
			<div className="timeline-steps">
				<div className="timeline-single-step timeline-single-step--half-item first-item" />
				{data.map((val, idx) => {
					return (
						<TimelineSingleStep
							key={idx}
							data={val}
							active={idx + 1 <= step}
							approved={idx + 1 <= approvedSteps || false}
							lastItem={data.length === idx + 1}
						/>
					);
				})}
			</div>
			<div className="timeline-steps__mobile-label">
				<strong>{data[step - 1].label}</strong>
			</div>
		</Fragment>
	);
};

export default TimelineSteps;
